import React, { useState } from "react";
import axios from "axios";
import { domainServer } from "../constant";
import APIs from "../constant/endpoint";

const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleRegister = async () => {
    try {
      const response = await axios.post(`${domainServer}${APIs.register}`, {
        username,
        password,
      });
      setMessage(response.data); // Gán tin nhắn từ phản hồi vào state message
    } catch (error) {
      setMessage(error.response.data); // Gán tin nhắn lỗi từ phản hồi vào state message
    }
  };

  return (
    <div>
      <h2>Register</h2>
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleRegister}>Register</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Register;
